import { AxiosResponse } from 'axios';
import { betActivity } from '@/api/bet';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IActivityFilters, IBetApiListResponse } from '@/types/bet';
import { IListParams } from '@/types/service';

export const activityService = {
    async list(params: IListParams<IActivityFilters>): Promise<AxiosResponse<IBetApiListResponse>> {
        try {
            const response = await baseListService<IBetApiListResponse>(betActivity, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Activity API Error:', e);
            throw new AppError(`Unable to load activity list, request error`, { cause: e });
        } finally {
        }
    },
};
